import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import type { Activity } from "@repo/app-types/entities/activity";
import { fetchNonEmptyInterviewsForProject } from "../interviews/interviewsSlice.js";

export const activitiesAdapter = createEntityAdapter<Activity>();

const initialState = activitiesAdapter.getInitialState<{
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}>({
  status: "idle",
  error: null,
});

const activitiesSlice = createSlice({
  name: "activities",
  initialState,
  reducers: {
    activityAdded: activitiesAdapter.addOne,
    activitiesAdded: activitiesAdapter.addMany,
    activityRemoved: activitiesAdapter.removeOne,
    activityUpdated: activitiesAdapter.updateOne,
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchNonEmptyInterviewsForProject.fulfilled,
      (state, action) => {
        state.status = "succeeded";
        activitiesAdapter.addMany(state, action.payload.activities);
      },
    );
  },
});

export const {
  activityAdded,
  activitiesAdded,
  activityRemoved,
  activityUpdated,
} = activitiesSlice.actions;
export default activitiesSlice.reducer;
